import React from 'react';
import withVirtualScroll from '../../../../dispatcher/hoc/withVirtualScroll';
import { PureComponent } from '../../../../dispatcher/modules';
import * as _ from 'lodash';
import PuzzleComboBox from './PuzzleComboBox';
import {
  PUZZLE_REMOTE_COMBO_PROPS,
  PUZZLE_REMOTE_COMBO_STATE
} from './Types';
import uuid from 'uuid-random';

/**
 * Remote data and filter combo box
 */
class PuzzleRemoteCombo extends PureComponent<PUZZLE_REMOTE_COMBO_PROPS, PUZZLE_REMOTE_COMBO_STATE> {
  moduleId = uuid();

  /**
   * Call external parseData function
   * @param data
   */
  parseData = (data: any) => {
    if (_.isFunction(this.props.parseData)) {
      data = this.props.parseData(data);
    }

    return data;
  };

  /**
   * Set data is function from virtual scroll component
   * preferably it should not be changed
   * @param data
   */
  setData = (data: any) => {
    _.get(this, 'props.setData') && this.props.setData(data);
  };

  renderBody() {
    let popupClass = 'data-preventrecorddeselect';

    if (this.props.virtual.total < 6) {
      popupClass += ' tp-remote-combo-box-popup';
    }

    return (
      <PuzzleComboBox
        {...this.props}
        popupSettings={{
          popupClass
        }}
      />
    );
  }
}

export default withVirtualScroll(PuzzleRemoteCombo);
